





import { Component, Prop, Vue } from "vue-property-decorator";

interface IList {
  category: string;
}

@Component({})
export default class StaandartCategoryCount extends Vue {
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Array, default: () => [] }) list!: Array<IList>;

  get count(): number {
    if (!this.id) return 0;
    let count = 0;
    this.list.forEach((el) => {
      if (el.category == this.id) count += 1;
    });
    return count;
  }
}
